import React from 'react';

const isReactElement = (element: any): element is React.ReactElement => {
  return React.isValidElement(element);
};

export const setAriaControls = (content: React.ReactNode) => {
  return {
    ...(isReactElement(content) ? { 'aria-controls': content.props.id } : {}),
  };
};
